export default "__VITE_PUBLIC_ASSET__a69f1b05__"